import { render, staticRenderFns } from "./TheEthBlocksLayout.vue?vue&type=template&id=089beba3"
import script from "./TheEthBlocksLayout.vue?vue&type=script&lang=js"
export * from "./TheEthBlocksLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports